import { Stack, Typography } from "@mui/material";

import { OneflowContractRefDto } from "@/core/api/generated/v1";

import FoldableBlock from "../../Display/FoldableBlock";
import EntityCreatedByInfoDisplay from "../../EntityInfo/EntityCreatedByInfoDisplay";
import EntityUpdatedByInfoDisplay from "../../EntityInfo/EntityUpdatedByInfoDisplay";
import FieldValue from "../../Form/Display/FieldValue";
import AppIcon from "../../Icons/AppIcon";
import AppLink from "../../Link/AppLink";

const defaultDisplayProps = {
  placeholder: true,
};

export interface OneflowContractRefDisplayProps {
  contractRef: OneflowContractRefDto;
  displayProps?: typeof defaultDisplayProps;
}

export function OneflowContractRefDisplay({
  contractRef,
  displayProps,
}: OneflowContractRefDisplayProps) {
  displayProps = {
    ...defaultDisplayProps,
    ...displayProps,
  };

  return (
    <Stack direction='column' gap={1}>
      <FieldValue label='Contract ID' isEmpty={!contractRef.contractId}>
        {contractRef.contractId}{" "}
        <AppLink to={undefined} href={contractRef.contractUrl} target='_blank'>
          Open <AppIcon of='openInNew' inText />
        </AppLink>
      </FieldValue>

      <FieldValue label='Oneflow user email' isEmpty={!contractRef.userEmail}>
        {contractRef.userEmail}
      </FieldValue>

      <FieldValue label='Created' isEmpty={!contractRef.createdAt}>
        <EntityCreatedByInfoDisplay entity={contractRef} direction='row' />
      </FieldValue>

      <FieldValue label='Updated' isEmpty={!contractRef.updatedAt}>
        <EntityUpdatedByInfoDisplay entity={contractRef} direction='row' />
      </FieldValue>

      <FoldableBlock
        defaultIsFolded
        trigger={{
          label: <Typography variant='h6'>Details</Typography>,
        }}
      >
        <Stack gap={1}>
          <FieldValue label='Workspace ID' isEmpty={!contractRef.workspaceId}>
            {contractRef.workspaceId}
          </FieldValue>

          <FieldValue label='Template ID' isEmpty={!contractRef.templateId}>
            {contractRef.templateId}
          </FieldValue>

          {contractRef.templateTypeId && (
            <FieldValue label='Template type ID' isEmpty={!contractRef.templateTypeId}>
              {contractRef.templateTypeId}
            </FieldValue>
          )}

          {contractRef.playbookId && (
            <FieldValue label='Playbook ID' isEmpty={!contractRef.playbookId}>
              {contractRef.playbookId}
            </FieldValue>
          )}

          {contractRef.integrationId && (
            <FieldValue label='Integration ID' isEmpty={!contractRef.integrationId}>
              {contractRef.integrationId}
            </FieldValue>
          )}

          {contractRef.integrationBlueprintId && (
            <FieldValue
              label='Integration blueprint ID'
              isEmpty={!contractRef.integrationBlueprintId}
            >
              {contractRef.integrationBlueprintId}
            </FieldValue>
          )}
        </Stack>
      </FoldableBlock>
    </Stack>
  );
}
